import { render, staticRenderFns } from "./usersScreen.vue?vue&type=template&id=78b872c6&scoped=true"
import script from "./usersScreen.vue?vue&type=script&lang=js"
export * from "./usersScreen.vue?vue&type=script&lang=js"
import style0 from "./usersScreen.vue?vue&type=style&index=0&id=78b872c6&prod&scoped=true&lang=css"
import style1 from "./usersScreen.vue?vue&type=style&index=1&id=78b872c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b872c6",
  null
  
)

export default component.exports